// extracted by mini-css-extract-plugin
export default {"customMenu":"CustomMenu_customMenu__aTk+G","customMenuLarge":"CustomMenu_customMenuLarge__IuS6J"};